T.FAQ = Class(
	/**
	 * @lends {T.FAQ#}
	 */
	{
		__construct(par) {
			par = par || {};

			let questionsCount = 0;
			if (par.questions && par.questions.length) {
				questionsCount = par.questions.length;
			} else {
				questionsCount = Number(
					D.Lang.get(par.prefix + '.questions.count', '0'));
			}
			if (!questionsCount) {
				this.node = mkE({
					tag: 'span'
				});
				return;
			}

			if (typeof par.title === 'undefined') {
				par.title = t('faq.title');
			}
			if (par.more !== false) {
				par.more = true;
			}

			let attr = {
				itemscope: '',
				itemtype: 'https://schema.org/FAQPage'
			};

			if (typeof par.itemscope !== 'undefined') {
				attr.itemscope = par.itemscope;
				if (attr.itemscope === null) {
					delete attr.itemscope;
				}
			}

			if (typeof par.itemtype !== 'undefined') {
				attr.itemtype = par.itemtype;
				if (attr.itemtype === null) {
					delete attr.itemtype;
				}
			}

			this.node = mkE({
				tag: 'div',
				className: 'FAQ',
				attr: attr
			});

			if (par.className) {
				this.node.className += ' ' + par.className;
			}

			let content = mkE({
				tag: 'div',
				className: 'faq-content',
				els: [
					{
						tag: 'h2',
						text: par.title
					}
				]
			}).append(this.node);

			if (par.intro) {
				mkE({
					tag: 'p',
					className: 'intro',
					innerHTML: par.intro
				}).append(content);
			}

			this.accordion = mkE({
				tag: 'div',
				className: 'accordion'
			}).append(content);

			if (par.questions) {
				for (let i = 0; i < par.questions.length; i++) {
					let q = par.questions[i];
					this._drawQuestion(
						q.question,
						q.answer,
						par.prefix + i
					);
				}
			} else {
				if (!questionsCount) {
					if (D.DEV) {
						console.warn(`FAQ "${par.prefix}" has no questions`);
					}
					this.node.style.display = 'none';
				}
				for (let i = 0; i < questionsCount; i++) {
					this._drawQuestion(
						D.Lang.get(par.prefix + '.questions.' + i),
						D.Lang.get(par.prefix + '.answers.' + i),
						par.prefix + i
					);
				}
			}

			if (par.more) {
				mkE({
					tag: 'div',
					className: 'mt-4 faq--more',
					els: [
						{
							tag: 'a',
							href: D.url('faq'),
							text: t('faq.more')
						}
					]
				}).append(this.node);
			}
		},
		_drawQuestion(question, answer, i) {
			mkE({
				tag: 'div',
				className: 'section',
				attr: {
					itemscope: '',
					itemprop: 'mainEntity',
					itemtype: 'https://schema.org/Question'
				},
				id: 'section-' + i,
				els: [
					{
						tag: 'input',
						type: 'checkbox',
						name: 'tab',
						id: 'tab-' + i
					},
					{
						tag: 'label',
						attr: {
							for: 'tab-' + i,
							itemprop: 'name'
						},
						els: [
							{
								tag: 'h3',
								className: 'h4',
								text: question
							},
							{
								tag: 'div',
								className: 'toggle'
							}
						]
					},
					{
						tag: 'div',
						className: 'tabContent',
						attr: {
							itemscope: '',
							itemprop: 'acceptedAnswer',
							itemtype: 'https://schema.org/Answer'
						},
						els: [
							formatTextNode(
								mkE({
									tag: 'div',
									attr: {
										itemprop: 'text'
									},
									text: answer
								})
							)
						]
					}
				]
			}).append(this.accordion);
		}
	},
	mkE.Base
);

T.FAQ.hasPrefixQuestions = function(prefix) {
	return Number(D.Lang.get(prefix + '.questions.count', '0')) > 0;
};